import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addLongPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
} from './utils';

export const straddle: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strike,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  const straddleStrike = strike ? strike : findClosestStrikePrice(strikesAtExpiration, spot);

  return {
    optionPositions: [
      addLongCall({
        strike: straddleStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[straddleStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[straddleStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addLongPut({
        strike: straddleStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[straddleStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[straddleStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
